"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = new Set(["esnext.global-this", "esnext.string.match-all"]);

exports.default = _default;